import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["currentVisibleDate", "range", "setCurrentVisibleDate", "value", "onChange", "minDate", "maxDate", "disableDates", "locale"],
  _excluded2 = ["date", "label"];
import React, { useMemo } from 'react';
import { cnBem } from '@carnica/utils';
import { usePrevious } from '@beef/react';
import { eachDayOfInterval, endOfWeek, format, startOfWeek } from 'date-fns-new';
import { AnimatePresence, motion } from 'framer-motion';
import { Grid } from "../../Grid";
import { Cell } from "../../Cell";
import { MonthSelector } from "../../MonthSelector";
import { useDaysList } from "../../hooks/useDaysList";
import { getMonthList } from "../../utils/date";
import styles from "./styles.pcss";
var cnCalendarBlockDay = cnBem('day-block', styles);
var variants = {
  enter: function enter(direction) {
    return {
      x: direction > 0 ? 1000 : -1000,
      opacity: 0
    };
  },
  center: {
    zIndex: 1,
    x: 0,
    opacity: 1
  },
  exit: function exit(direction) {
    return {
      zIndex: 0,
      x: direction < 0 ? 1000 : -1000,
      opacity: 0
    };
  }
};
export var CalendarBlockDay = function CalendarBlockDay(props) {
  var currentVisibleDate = props.currentVisibleDate,
    range = props.range,
    setCurrentVisibleDate = props.setCurrentVisibleDate,
    value = props.value,
    onChange = props.onChange,
    minDate = props.minDate,
    maxDate = props.maxDate,
    disableDates = props.disableDates,
    locale = props.locale,
    otherProps = _objectWithoutProperties(props, _excluded);
  var days = useDaysList({
    currentVisibleDate: currentVisibleDate,
    range: range,
    value: value,
    onChange: onChange,
    minDate: minDate,
    maxDate: maxDate,
    disableDates: disableDates
  });
  var previousMonth = usePrevious(currentVisibleDate.getMonth()) || currentVisibleDate.getMonth();
  var diff = currentVisibleDate.getMonth() - previousMonth;
  var weekDays = useMemo(function () {
    return eachDayOfInterval({
      start: startOfWeek(currentVisibleDate, {
        weekStartsOn: 1
      }),
      end: endOfWeek(currentVisibleDate, {
        weekStartsOn: 1
      })
    }).map(function (day) {
      return format(day, 'EEEEEE', {
        locale: locale
      });
    });
  }, [locale]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(MonthSelector, {
    items: getMonthList(currentVisibleDate),
    locale: locale,
    onChange: setCurrentVisibleDate,
    value: currentVisibleDate,
    "data-t-id": "CalendarBlocks-CalendarBlockDay"
  }), /*#__PURE__*/React.createElement(motion.div, _extends({}, otherProps, {
    className: cnCalendarBlockDay(),
    layoutRoot: true
  }), /*#__PURE__*/React.createElement(Grid, {
    className: cnCalendarBlockDay('weeks')
  }, weekDays.map(function (el) {
    return /*#__PURE__*/React.createElement(Cell, {
      disabled: true,
      key: el,
      tagName: "div"
    }, el);
  })), /*#__PURE__*/React.createElement(motion.div, {
    className: cnCalendarBlockDay('divider')
  }), /*#__PURE__*/React.createElement(AnimatePresence, {
    custom: diff,
    initial: false
  }, /*#__PURE__*/React.createElement(motion.div, {
    animate: "center",
    className: cnCalendarBlockDay('container'),
    custom: diff,
    exit: "exit",
    initial: "enter",
    key: currentVisibleDate.getMonth(),
    transition: {
      x: {
        type: 'spring',
        stiffness: 300,
        damping: 30
      },
      opacity: {
        duration: 0.2
      }
    },
    variants: variants
  }, /*#__PURE__*/React.createElement(Grid, {
    className: cnCalendarBlockDay('days')
  }, days.map(function (_ref) {
    var date = _ref.date,
      label = _ref.label,
      params = _objectWithoutProperties(_ref, _excluded2);
    return /*#__PURE__*/React.createElement(Cell, _extends({
      key: date.toDateString()
    }, params), label);
  }))))));
};